import { withCurrentParams } from 'actions/utils';
import { getSceneLayerIds } from 'actions/Broadcast/utils';
import { BackgroundStyles } from 'constants/LayerPositions';
import { BACKGROUND_POSITION_TOGGLE } from 'store/eventConstants';
import { BROADCAST_UPDATE_BACKGROUND_POSITION } from 'actions/Types';
import { updateSceneLayers } from '@shoflo/studio-redux/actions';

export default (backgroundId, position) => {
  return withCurrentParams(
    (dispatch, { teamId, eventId, broadcastId }, getState, socket) => {
      const action = {
        type: BROADCAST_UPDATE_BACKGROUND_POSITION,
        request: async apiClient => {
          const payload = {
            layer: {
              title: position,
              style: BackgroundStyles[position]
            }
          };

          const broadcast = await apiClient.broadcast.updateBackground(
            teamId,
            eventId,
            broadcastId,
            backgroundId,
            payload
          );
          const {
            meeting: { attendeeResponse }
          } = getState();
          const { backgrounds } = broadcast;
          const updatedBackground = backgrounds.find(
            backgrounds => backgrounds._id === backgroundId
          );
          const { hidden } = updatedBackground.source;

          if (!hidden) {
            const sceneLayerIds = getSceneLayerIds(broadcast);
            dispatch(updateSceneLayers(sceneLayerIds));
          }
          // notify other directors
          socket.emit(BACKGROUND_POSITION_TOGGLE, {
            broadcastId,
            backgroundId,
            notifyingDirector:
              attendeeResponse && attendeeResponse.Attendee.AttendeeId
          });
          return updatedBackground;
        }
      };
      dispatch(action);
    }
  );
};
